/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_For_Over_135_CurrenciInputs */

const en_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support for over 135+ currencies`)
};

const es_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte para más de 135 monedas`)
};

const fr_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prise en charge de plus de 135 devises`)
};

const de_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung für über 135+ Währungen`)
};

const ja_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`135以上の通貨に対応`)
};

const zh_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持超过 135 种货币`)
};

const ar_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم لأكثر من 135+ عملة`)
};

const id_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan untuk lebih dari 135+ mata uang`)
};

const it_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto per oltre 135+ valute`)
};

const ru_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка более 135+ валют`)
};

const pt_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte para mais de 135 moedas`)
};

const ko_support_for_over_135_currenci = /** @type {(inputs: Support_For_Over_135_CurrenciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`135개 이상의 통화 지원`)
};

/**
* | output |
* | --- |
* | "Support for over 135+ currencies" |
*
* @param {Support_For_Over_135_CurrenciInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_for_over_135_currenci = /** @type {((inputs?: Support_For_Over_135_CurrenciInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_For_Over_135_CurrenciInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_for_over_135_currenci(inputs)
	if (locale === "es") return es_support_for_over_135_currenci(inputs)
	if (locale === "fr") return fr_support_for_over_135_currenci(inputs)
	if (locale === "de") return de_support_for_over_135_currenci(inputs)
	if (locale === "ja") return ja_support_for_over_135_currenci(inputs)
	if (locale === "zh") return zh_support_for_over_135_currenci(inputs)
	if (locale === "ar") return ar_support_for_over_135_currenci(inputs)
	if (locale === "id") return id_support_for_over_135_currenci(inputs)
	if (locale === "it") return it_support_for_over_135_currenci(inputs)
	if (locale === "ru") return ru_support_for_over_135_currenci(inputs)
	if (locale === "pt") return pt_support_for_over_135_currenci(inputs)
	return ko_support_for_over_135_currenci(inputs)
});